import { BASEURI, headers } from "../../utils/helper"
import { asyncThunkWrapper } from "../thunkHandler"
import { createAsyncThunk } from "@reduxjs/toolkit"

/* ---------------------------------------
Categories
--------------------------------------- */

// Handle retrieve categories
export const handleRetrieveBlogCategories = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      search: data?.search || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        url: `${BASEURI}/public/blog/category/retrieve-all`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)

/* ---------------------------------------
Blog
--------------------------------------- */

// Handle retrieve all blogs
export const handleRetrieveBlogs = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      search: data?.search || null,
      currentPage: data?.currentPage || null,
      categoryId: data?.categoryId || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        url: `${BASEURI}/public/blog/retrieve-all`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)

// Handle retrieve single blog
export const handleRetrieveSingleBlog = createAsyncThunk(
  "retrieveSingle",
  async (id, thunkAPI) => {

    return asyncThunkWrapper(
      {
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/public/blog/retrieve/${id}`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)

export const handleRetrievePopularBlogs = createAsyncThunk(
  "retrievePopular",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        url: `${BASEURI}/public/blog/retrieve-popular`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)